<template>
  <div class="nav-wrapper" v-bind:class="{ opened: !menu_closed }">
    <div class="nav-toggle" @click="toggle_menu">
      <i v-if="menu_closed" class="fas fa-bars icon"></i>
      <i v-else class="fas fa-angle-left icon"></i>
    </div>

    <div class="nav-container" v-bind:class="{ closed: menu_closed }">
      <p class="subtitle"> User profile </p>
      <label>
        <input type="checkbox" v-model='light_theme' @click="change_theme">
        <span> Light theme: {{light_theme}} </span>
      </label>
      
    </div>
  </div>
</template>

<script>
import {bus} from '../../main'

export default {
  data() {
    return {
      menu_closed: true,
      light_theme: false,
    }
  },
  methods: {
    toggle_menu() {    
      this.menu_closed = !this.menu_closed
      this.$emit('menu-toggled')
    },
    change_theme() {
      this.light_theme = !this.light_theme 
      bus.$emit('light_theme')
    }
  }
}
</script>

<style scoped>
  .nav-wrapper {
    height: 100%;
    width: 3%;
    position: fixed;
    top: 0;
    left: 0px;
    border-right: 3px solid var(--element-background);
    background-color: var(--main-background);
    box-shadow: 6px 3px 24px -9px rgba(0,0,0,0.85);
    -webkit-box-shadow: 6px 3px 24px -9px rgba(0,0,0,0.85);
    -moz-box-shadow: 6px 3px 24px -9px rgba(0,0,0,0.85);
    transition: 250ms ease-in-out;
    z-index: 1;
  }
  .nav-container {
    /* border: 1px dashed white; */
    color: var(--font);
    position: absolute;
    top: 0;
    right: 0%;
    width: 100%;
    height: 100%;
    transition: 200ms;
    transition-delay: 100ms;
  } 
  .opened {
    width: 250px;
    border-right: 2px solid var(--primary);
    background-color: var(--menu-background);
  }
  .closed {
    transition: 50ms;
    transition-delay: 50ms;
    right: 500%;
  }
  .nav-toggle {
    position: absolute;
    top: 100px;
    right: -17px;
    height: 35px;
    width: 35px;
    border: 2px solid var(--primary);
    background-color: var(--main-background);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
  }
  .nav-toggle .icon {
    font-size: 16px
  }
  .nav-toggle:hover .icon {
    color: var(--primary);
  }
  




  @media only screen and (max-width: 768px) {
    .nav-wrapper {
      display: none;
    }
  }
</style>